export const DATA_INSIGHTS_TAB_INTERACTION_SUMMARY = 'interactionSummary'

export const DATA_INSIGHTS_TAB_AI_ANALYTICS = 'aiAnalytics'

export interface InteractionSummaryProps  {
  clientAppId: string,
  ccrId: number,
  autoQAHasData: boolean,
  autoQAReloadTimestamp: number,
  autoQAFormId: number,
}

export interface SentimentData {
  overallAgentSentiment: number | null,
  overallAgentSentimentReason: string | null,
  overallUserSentiment: number | null,
  overallUserSentimentReason: string | null,
}

